/**
 * useAutoSave — enregistre automatiquement une valeur après un délai d'inactivité (AUTOSAVE_DEBOUNCE_MS).
 * Renvoie un statut ('idle' | 'saving' | 'saved' | 'error') pour l'indicateur « Enregistré ✓ ».
 * N'enregistre pas au montage initial. `save` reçoit la valeur courante.
 */
import { useEffect, useRef, useState } from 'react';
import { AUTOSAVE_DEBOUNCE_MS } from '../constants';

export function useAutoSave(value, save) {
  const [status, setStatus] = useState('idle');
  const first = useRef(true);
  const timer = useRef();

  useEffect(() => {
    if (first.current) { first.current = false; return; }
    setStatus('saving');
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try { await save(value); setStatus('saved'); setTimeout(() => setStatus('idle'), 1500); }
      catch { setStatus('error'); }
    }, AUTOSAVE_DEBOUNCE_MS);
    return () => clearTimeout(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(value)]);

  return status;
}

/** Petit indicateur textuel du statut d'enregistrement automatique. */
export function AutoSaveStatus({ status }) {
  if (status === 'saving') return <span className="text-[12px] text-n500">Enregistrement…</span>;
  if (status === 'saved') return <span className="text-[12px] text-gold700">Enregistré ✓</span>;
  if (status === 'error') return <span className="text-[12px] text-red-600">Échec · réessai…</span>;
  return null;
}
